import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from 'src/app/common-services/translation.service';
import { CompanyService } from 'src/app/common-services/Company.service';
import { HttpRequestService } from 'src/app/common-services/http-request.service';

@Component({
  selector: 'app-gc_company_name',
  templateUrl: './gc_company_name.component.html',
  styleUrls: ['./gc_company_name.component.css']
})
export class Gc_company_nameComponent implements OnInit {

  constructor(
    private companyService: CompanyService,
    private translate: TranslateService,
    private lang: TranslationService,
    private http: HttpRequestService
  ) { }
  
  gc_company_name: string = "";
  currentUser: any;

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user_data'));
    let id = this.companyService.getCurrentCompany();
    this.getGCCompanyName(id);
  }

  getGCCompanyName(id: number) {
    if (id > 0) {
      let url = '/general-contractor/get-gc-extender/?is_active=True&show=All&id=' + id
      this.http.request('get', url, null).subscribe((res: any) => {
        this.gc_company_name = res[0].company_name || "-";
      });
    }else{
      this.gc_company_name = "-";
    }
  }

}
